<template>
  <div>
    <TeJobWebdesignCover />

    <TeJobAbout>
      <template #title>
        Webデザイン
      </template>
      <template #content>
        <p class="co-display-10 mb-3 text-co-gray-500">
          Webデザインの学習プログラムにおいて
          <br class="hidden md:block">
          受講生の「わからない」をリモートにてサポートしていただきます。
          <br class="hidden md:block">
          あなたのスキルを受講生の成長に活かしてみませんか？
        </p>
        <a href="/job">
          テックアカデミーのメンターについて
        </a>
      </template>
    </TeJobAbout>

    <TeJobTarget />

    <TeJobMessage>
      <template #chatsupportText>
        15時〜23時の間のシフト制で、
      </template>
    </TeJobMessage>

    <TeJobWorkStyle />

    <section
      id="pickup-mentor"
      class="co-bg-striped text-center"
    >
      <div class="co-container-lg px-4 py-20">
        <h2 class="co-heading-2-caption">
          メンター紹介
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] text-left leading-base text-co-gray-600 md:text-center">
          テックアカデミーではメンターが多数在籍しています。
          <br class="hidden md:block">
          現在活躍している一部のメンターをご紹介。
        </h3>
        <div class="flex flex-wrap justify-center text-left">
          <div class="basis-full md:basis-8/12">
            <div class="flex flex-wrap">
              <div class="basis-full px-4 text-center md:basis-1/4">
                <img
                  src="~/assets/images/Te/TeJob/Mentor/mentor-sasagawa.jpg"
                  class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
                  alt="Kiyoshi Sasagawa"
                  loading="lazy"
                >
              </div>
              <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
                <h4 class="co-display-10 text-center md:text-left">
                  Kiyoshi Sasagawa
                </h4>
                <p>
                  20年ほど前から独学でHTMLを始める。CSS・JavaScript/jQueryを得意とし、WordPress・Photoshop・Illustratorなどの技術にも明るい。印刷物系のデザイナーの経験を活かし、コーディングの傍らデザイン面のコンサルを行うこともある。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <TeJobMentorSlider />

    <!-- スキル -->
    <section
      id="skill"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pb-[3.75rem] pt-20 lg:pb-10">
        <h2 class="co-heading-2">
          Webデザインメンターに必要なスキル
        </h2>
        <div class="grid grid-cols-1 justify-center gap-9 lg:grid-cols-2 lg:gap-x-8 lg:gap-y-10">
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faObjectGroup"
                class="h-12 w-[3.25rem] text-[#cdbf49]"
              />
            </template>
            <template #title>
              デザインに対するロジカルな思考
            </template>
            <template #description>
              Webデザインに対する理由や説明が可能なこと
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-wireframe.png"
                alt="Webサイトの設計"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Webサイトの設計
            </template>
            <template #description>
              Web制作における設計工程の経験があること
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/adobe-photoshop.svg"
                alt="Photoshop"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Photoshop
            </template>
            <template #description>
              Photoshopを使用した画像の加工が可能なこと
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faHtml5"
                class="h-12 w-[3.25rem] text-[#e44d26]"
              />
            </template>
            <template #title>
              HTML/CSS3/Sass
            </template>
            <template #description>
              HTML/CSSのコーディング技術とSassの知識
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-jquery.svg"
                alt="jQuery"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              jQuery
            </template>
            <template #description>
              jQueryおよびプラグインの使用が可能なこと
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-github.png"
                alt="Git/GitHub"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Git/GitHub
            </template>
            <template #description>
              Git/GitHubを使用できること
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faFileLines"
                class="h-12 w-[3.25rem] text-[#5e98a9]"
              />
            </template>
            <template #title>
              ポートフォリオ
            </template>
            <template #description>
              ポートフォリオを持っていること
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faWrench"
                class="h-12 w-[3.25rem] text-[#999]"
              />
            </template>
            <template #title>
              Web制作実績
            </template>
            <template #description>
              Web制作実績が5サイト以上あること
            </template>
          </TeJobSkill>
        </div>
      </div>
    </section>

    <TeJobFlow />

    <TeJobEntry course-name-path="webdesign" />
  </div>
</template>

<script setup lang="ts">
import { metaTags } from '~/utility/constants/metaTags'

import TeJobWebdesignCover from '~/components/Te/TeJob/Webdesign/TeJobWebdesignCover.vue'
import TeJobAbout from '~/components/Te/TeJob/TeJobAbout.vue'
import TeJobTarget from '~/components/Te/TeJob/TeJobTarget.vue'
import TeJobMessage from '~/components/Te/TeJob/TeJobMessage.vue'
import TeJobWorkStyle from '~/components/Te/TeJob/TeJobWorkStyle.vue'
import TeJobMentorSlider from '~/components/Te/TeJob/TeJobMentorSlider.vue'
import TeJobSkill from '~/components/Te/TeJob/TeJobSkill.vue'
import TeJobFlow from '~/components/Te/TeJob/TeJobFlow.vue'
import TeJobEntry from '~/components/Te/TeJob/TeJobEntry.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faObjectGroup, faFileLines, faWrench } from '@awesome.me/kit-65d95819ce/icons/classic/solid'
import { faHtml5 } from '@awesome.me/kit-65d95819ce/icons/classic/brands'

useJobHead()

useHead({
  title: 'Webデザインメンター（講師）の募集 |テックアカデミー',
  meta: [
    ...metaTags({
      description:
        '受講生をサポートするWebデザインメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterTitle: 'Webデザインメンター（講師）の募集',
      twitterDescription:
        '受講生をサポートするWebデザインメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterImage: '/_nuxt/ogp/og-image-mentor-webdesign.jpg',
      ogTitle: 'Webデザインメンター（講師）の募集',
      ogDescription:
        '受講生をサポートするWebデザインメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のスキルを活用したい場合は、まずはお気軽にご応募ください。',
      ogUrl: '/jobs/webdesign',
      ogImage: '/_nuxt/ogp/og-image-mentor-webdesign.jpg',
    }),
  ],
})
</script>
